export default function ({ singleSpa, isValidName }) {
  const validateDomainName = (apps, appName) => {
    if (!isValidName(apps, appName)) {
      const message = `domain [${appName}] is duplicated`
      throw new Error(JSON.stringify({ message: `[${process.env.APP_NAME}] > ${message}` }))
    }
  }

  const getMountElement = (name, hideLayout) => {
    if (hideLayout) return 'main-app-no-layout'
    if (['zsuite-sidebar', 'campaign-sidebar'].includes(name)) return 'main-sidebar'
    if (name === 'zsuite-navbar') return 'main-navbar'
    if (name === 'conversion-inbox-sidebar') return 'secondary-sidebar'
    if (name === 'magic-button') return 'magic-button'
    return 'main-app'
  }

  return (domains, authenticated) => {
    const { apps } = domains || {}
    if (!apps || !Array.isArray(apps)) return

    try {
      let registeredCount = 0

      apps
        .filter(({ auth }) => authenticated || !auth)
        .forEach((app) => {
          const {
            name, dependencies, rules, hideLayout = false,
          } = app

          if (singleSpa.getAppNames().includes(name)) {
            console.warn(`[${process.env.APP_NAME}] App "${name}" já registrada.`)
            return
          }

          validateDomainName(apps, name)

          const idToMount = getMountElement(name, hideLayout)
          const domElement = document.getElementById(idToMount)

          if (!domElement) {
            console.warn(`[${process.env.APP_NAME}] DOM element [${idToMount}] não encontrado para o app "${name}".`)
            return
          }

          singleSpa.registerApplication(name, dependencies, rules, {
            domElement,
          })

          // eslint-disable-next-line no-plusplus
          registeredCount++
        })

      if (registeredCount > 0 && !window.singleSpaStarted) {
        singleSpa.start()
        window.singleSpaStarted = true
        console.log(`[${process.env.APP_NAME}] singleSpa iniciado.`)
      }
    } catch (ex) {
      console.error(ex)
      throw new Error(JSON.stringify({
        message: `[${process.env.APP_NAME}] > apps registration > ${ex}`,
        error: ex.message,
      }))
    }
  }
}
